<div
  class="w-64 rounded-2xl border border-brand bg-brand-surface-card shadow-xl overflow-hidden"
>
  <div class="px-4 py-4 border-b border-brand-subtle">
    <h3 *ngIf="hasRealUserName()" class="text-base font-semibold text-brand-ink">
      {{ userName }}
    </h3>
    <p *ngIf="hasEmail()" class="text-sm text-brand-muted mt-1">
      {{ userEmail }}
    </p>
    <p *ngIf="hasAccountInfo()" class="text-xs text-brand-muted-light mt-2">
      {{ accountInfo }}
    </p>
    <p *ngIf="hasRealDisplayName()" class="text-sm text-brand-ink-secondary font-medium mt-3">
      {{ displayName }}
    </p>
  </div>
  <div class="px-4 py-3 space-y-2">
     <button
      type="button"
      (click)="onLogOut()"
      class="w-full px-4 py-3 text-sm font-semibold text-brand-danger bg-brand-danger/10 border border-brand-danger/20 rounded-xl hover:bg-brand-danger/20 cursor-pointer transition-all duration-200 flex items-center justify-between"
    >
      <span>{{ 'USER_PROFILE.LOGOUT' | translate }}</span>
      <svg
        class="w-4 h-4"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M17 16l4-4-4-4m4 4H7"
        />
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M7 4H3v16h4"
        />
      </svg>
    </button>
  </div>
</div>
